import BlogTomcat from './BlogTomcat';
export default BlogTomcat;
